export default "__VITE_ASSET__D9fL0ce3__"